import React from 'react';

export const SEOStripItem = ({ item }) => {
    return <div className="footer-blocks-strip-item">
        <div className="footer-blocks-strip-item--wrapper">
            {
                item.image &&
                <div className="footer-blocks-strip-item__image-wrapper">
                    <img src={item.image} loading="lazy" alt=""/>
                </div>
            }
            <h2 className="footer-blocks-strip-item__title" dangerouslySetInnerHTML={{ __html: item.title }} />
        </div>
        <div className="footer-blocks-strip-item__text" dangerouslySetInnerHTML={{ __html: item.text }} />
    </div>;
};
